import React from "react";

// --- ENHANCED MOCK DATA ---
const TICKETS = [
  {
    id: 101,
    title: "Sufi Night: Live",
    type: "Music Concert",
    date: "15 NOV 2026 • 7:00 PM",
    venue: "Nicco Park, Kolkata",
    qty: "2 ADULTS",
    seat: "BLOCK A, ROW 4",
    gate: "GATE 2",
    status: "Confirmed"
  },
  {
    id: 102,
    title: "Tech Summit '26",
    type: "Conference",
    date: "02 DEC 2026 • 9:00 AM",
    venue: "Taj Lands End, Mumbai",
    qty: "1 VIP PASS",
    seat: "TABLE 12",
    gate: "MAIN LOBBY",
    status: "Confirmed"
  },
  {
    id: 103,
    title: "Jaipur Jazz Festival",
    type: "Cultural",
    date: "20 JAN 2027 • 4:00 PM",
    venue: "Rambagh Palace, Jaipur",
    qty: "2 WEEKEND PASS",
    seat: "GENERAL ACCESS",
    gate: "WEST WING",
    status: "Confirmed"
  }
];

const TicketsView = () => (
  <div className="animate-fade-in-up pb-12 font-sans">

    {/* --- HEADER --- */}
    <div className="flex items-center justify-between mb-8">
      <div>
        <h2 className="text-2xl font-black text-[#0B1F33]">My Wallet</h2>
        <p className="text-xs text-gray-500 font-medium mt-1">Access your digital passes</p>
      </div>
      <button className="text-xs font-bold text-[#D4AF37] uppercase tracking-wider hover:underline flex items-center gap-1">
        History <span className="material-symbols-outlined text-sm">history</span>
      </button>
    </div>

    {/* --- TICKET GRID --- */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {TICKETS.map((ticket) => (
        <div
          key={ticket.id}
          className="group relative bg-[#0B1F33] rounded-[1.5rem] p-6 text-white shadow-xl shadow-[#0B1F33]/20 flex flex-col hover:-translate-y-1 transition-transform duration-300 overflow-hidden"
        >
          {/* Abstract Decor */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-[#D4AF37]/10 rounded-full blur-[40px] -translate-y-1/2 translate-x-1/2 pointer-events-none"></div>
          <div className="absolute bottom-0 left-0 w-24 h-24 bg-[#D4AF37]/5 rounded-full blur-[30px] translate-y-1/2 -translate-x-1/2 pointer-events-none"></div>

          {/* --- CARD HEADER --- */}
          <div className="flex justify-between items-start mb-6 relative z-10">
            <div className="space-y-1">
              <span className="inline-block px-2 py-0.5 rounded-md bg-white/10 border border-white/5 text-[10px] font-bold text-[#D4AF37] uppercase tracking-wider mb-2">
                {ticket.type}
              </span>
              <h3 className="text-xl font-bold leading-tight">{ticket.title}</h3>
              <p className="text-xs text-gray-300 flex items-center gap-1">
                <span className="material-symbols-outlined text-sm text-[#D4AF37]">location_on</span>
                {ticket.venue}
              </p>
            </div>

            {/* QR Code Placeholder */}
            <div className="bg-white p-2 rounded-xl flex-shrink-0 shadow-lg">
              <span className="material-symbols-outlined text-4xl text-[#0B1F33]">qr_code_2</span>
            </div>
          </div>

          {/* --- DIVIDER --- */}
          <div className="relative w-full h-px bg-dashed border-t border-dashed border-white/20 mb-6">
            {/* Cutout Circles */}
            <div className="absolute -left-[30px] -top-3 w-6 h-6 bg-gray-50 rounded-full"></div>
            <div className="absolute -right-[30px] -top-3 w-6 h-6 bg-gray-50 rounded-full"></div>
          </div>

          {/* --- TICKET DETAILS --- */}
          <div className="grid grid-cols-3 gap-4 mb-6 relative z-10">
            <div>
              <p className="text-[10px] text-gray-400 font-bold uppercase tracking-wider mb-1">Date</p>
              <p className="text-xs font-bold text-white">{ticket.date.split('•')[0]}</p>
              <p className="text-[10px] text-gray-400">{ticket.date.split('•')[1]}</p>
            </div>
            <div>
              <p className="text-[10px] text-gray-400 font-bold uppercase tracking-wider mb-1">Seat</p>
              <p className="text-xs font-bold text-white">{ticket.seat}</p>
              <p className="text-[10px] text-gray-400">{ticket.qty}</p>
            </div>
            <div className="text-right">
              <p className="text-[10px] text-gray-400 font-bold uppercase tracking-wider mb-1">Entry</p>
              <p className="text-xs font-bold text-[#D4AF37]">{ticket.gate}</p>
            </div>
          </div>

          {/* --- ACTIONS --- */}
          <div className="flex gap-3 mt-auto relative z-10">
            <button className="flex-1 bg-[#D4AF37] hover:bg-[#c5a02e] text-[#0B1F33] py-3 rounded-xl text-xs font-black uppercase tracking-widest transition-colors shadow-lg flex items-center justify-center gap-2">
              View Ticket
            </button>
            <button className="w-12 flex items-center justify-center bg-white/10 hover:bg-white/20 text-white rounded-xl transition-colors backdrop-blur-md">
              <span className="material-symbols-outlined text-lg">download</span>
            </button>
            <button className="w-12 flex items-center justify-center bg-white/10 hover:bg-white/20 text-white rounded-xl transition-colors backdrop-blur-md">
              <span className="material-symbols-outlined text-lg">share</span>
            </button>
          </div>

        </div>
      ))}
    </div>
  </div>
);

export default TicketsView;